import { NavbarNew, SidebarNew } from "../components/Navigation"
import Header from "../components/Header"
import ex from "../styles/eventosSociales.module.css"
import cx from "classnames"
import Footer from "../components/Footer"

export default function EventosSociales() {
    return (
        <>
            <NavbarNew engLink={ "/eng/" }/>
            <SidebarNew engLink={ "/eng/" }/>
            <Header routeName="eventosSociales" altName="Pecera redonda" titleText="EVENTOS SOCIALES"/>

            {/* GRANDES EVENTOS */}
            <div className={ cx(ex.grandes_eventos, "section") }>
                <div className={ cx(ex.grandes_eventos_content, "content") }>
                    <div className={ ex.grandes_eventos_title }>GRANDES EVENTOS, GRANDES RECUERDOS,<br/>SÓLO EN GRAN ACUARIO MAZATLÁN</div>
                    <div className={ ex.grandes_eventos_sep }></div>
                </div>
            </div>

            { /* CELEBRA EN GRAN ACUARIO */}
            <div className={ cx(ex.celebra, "section") }>
                <div className={ ex.celebra_img }>
                    <img src="/images/eventosSociales/celebra.png" srcSet="/images/eventosSociales/celebra.webp" alt="Celebra" Title="Celebra" />
                </div>
                <div className={ ex.celebra_des }>
                    <div className={ ex.celebra_des_t1 }>CELEBRA EN GRAN ACUARIO MAZATLÁN</div>
                    <div className={ ex.celebra_des_des }>Gran Acuario Mazatlán es el más grande de México y más importante de Latinoamérica, dedicado al Mar de Cortés y con un enfoque en la educación, investigación y divulgación del conocimiento, sin duda alguna marcará un referente en los acuarios del mundo, y es el marco perfecto para realizar su evento.</div>
                    <a href="#" className={ ex.celebra_des_btn }>COTIZAR</a>
                </div>
            </div>

            { /* FESTEJA CON NOSOTROS */}
            <div classsName={ cx(ex.festeja, "section") }>
                <div className={ cx(ex.festeja_content, "content") }>
                    <div className={ ex.festeja_title }>¡FESTEJA CON NOSOTROS!</div>
                    <div className={ ex.festeja_sep }></div>
                    <div className={ ex.festeja_des }>Realizamos con gran calidad y profesionalismo todo tipo de eventos.</div>
                </div>
            </div>

            <div className={ ex.festejos_tarjetas }>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>CORPORATIVOS</div>
                    <img src="/images/eventosSociales/corporativo.png" alt="Corporativo" />
                </div>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>SOCIALES</div>
                    <img src="/images/eventosSociales/sociales.png" alt="Sociales" />
                </div>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>INFANTILES</div>
                    <img src="/images/eventosSociales/infantiles.png" alt="Infantiles" />
                </div>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>RECREATIVOS</div>
                    <img src="/images/eventosSociales/recreativos.png" alt="Recreativos" />
                </div>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>CENAS ROMÁNTICAS</div>
                    <img src="/images/eventosSociales/cenas_romanticas.png" alt="Cenas romanticas" />
                </div>
                <div className={ ex.festejos_tarjetas_el }>
                    <div className={ ex.festejos_tarjetas_el_title }>SESIONES FOTOGRÁFICAS</div>
                    <img src="/images/eventosSociales/sesiones_fotograficas.png" alt="Sesiones fotograficas" />
                </div>
            </div>

            {/* NUESTRAS AREAS */}
            <div className={ cx(ex.areas, "section") }>
                <div className={ cx(ex.areas_content, "content") }>
                    <div className={ ex.areas_title }>NUESTRAS ÁREAS</div>
                    <div className={ ex.areas_sep }></div>
                </div>
                <div className={ ex.areas_con }>
                    <div className={ ex.areas_con_img }>
                        <img src="/images/eventosSociales/areas.png" alt="Areas" title="Areas"/>
                    </div>
                    <div className={ ex.areas_con_des }>
                        <div className={ ex.areas_con_des_salones }>
                            <div className={ ex.areas_con_des_salones_title }>
                                <div className={ ex.areas_con_des_salones_title_el }>SALONES</div>
                                <div className={ ex.areas_con_des_salones_title_el }>CAPACIDAD</div>
                                <div className={ ex.areas_con_des_salones_title_el }>HORA</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>GRAN JARDÍN</div>
                                <div className={ ex.areas_con_des_salones_el_title }>600 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>5</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>SALÓN OCEANICA+CORAL</div>
                                <div className={ ex.areas_con_des_salones_el_title }>200 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>5</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>SALÓN LAGUNA</div>
                                <div className={ ex.areas_con_des_salones_el_title }>150 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>5</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>PLAZA CENTRAL</div>
                                <div className={ ex.areas_con_des_salones_el_title }>100 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>5</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>TERRAZA CORMORANES</div>
                                <div className={ ex.areas_con_des_salones_el_title }>70 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>5</div>
                            </div>
                            <div className={ ex.areas_con_des_salones_el }>
                                <div className={ ex.areas_con_des_salones_el_title }>CENA PRIVADA</div>
                                <div className={ ex.areas_con_des_salones_el_title }>2 PX</div>
                                <div className={ ex.areas_con_des_salones_el_title }>2</div>
                            </div>
                        </div>
                        <div className={ ex.areas_con_des_salones_disclaimer }>Los precios están sujetos a cambios, teniendo en cuenta 7 días de vigencia.</div>
                        <a className={ ex.areas_con_des_salones_btn }>COTIZAR</a>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}